/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlastDto } from '../models/BlastDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BlastService {

  /**
   * @returns BlastDto OK
   * @throws ApiError
   */
  public static getJournalDocument({
    projectKey,
    blastId,
  }: {
    projectKey: string,
    blastId: number,
  }): CancelablePromise<BlastDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/blasts/{blastId}',
      path: {
        'projectKey': projectKey,
        'blastId': blastId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static downloadJournalDocument({
    projectKey,
    blastId,
  }: {
    projectKey: string,
    blastId: number,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/blasts/{blastId}/journal',
      path: {
        'projectKey': projectKey,
        'blastId': blastId,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static uploadJournalDocument({
    projectKey,
    blastId,
    formData,
  }: {
    projectKey: string,
    blastId: number,
    formData?: {
      file: Blob;
    },
  }): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/blasts/{blastId}/journal',
      path: {
        'projectKey': projectKey,
        'blastId': blastId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

}
